import { AnchoredContent, ContentParentLink, ContentSection, Author, ArticlesSlider, ActiveLink, ArrowButton, Share } from '@/components'
import { StyledContent, StyledTitle, StyledSection, StyledTime } from '@/components/styles'
import addSoftHyphenation from '@/lib/addSoftHyphenation'
import generateBlocks from '@/lib/generateBlocks'
import generateLinkParams from '@/lib/generateLinkParams'
import { useTranslation } from "react-i18next";

export default function ArticlePage(props) {
  const { title, blocks, author, similar, next, previous } = props
  const { t } = useTranslation("global");
  const [prevHref, prevAs] = generateLinkParams({ type: 'article', slug:previous?.slug })
  const [nextHref, nextAs] = generateLinkParams({ type: 'article', slug:next?.slug })

  return (
    <StyledContent withLine>
      <StyledContent.Container>
        <StyledContent.Columns>
          <ContentParentLink type="blog">{t('articles.title')}</ContentParentLink>

          <AnchoredContent arrow={false}
            navHeader={
              <StyledTitle size="large" mb="medium" as="h1">
                {addSoftHyphenation(title, 15)}
              </StyledTitle>
            }
          >
            {blocks && blocks.length > 0 && generateBlocks(blocks)}
          </AnchoredContent>
        </StyledContent.Columns>
        <StyledTime space>
          <div>   
            {author && (                   
              <StyledContent.Description>
                <StyledContent.Html >
                  <div style={{marginBottom:'15px'}}>Authored by:</div>
                </StyledContent.Html>
                <Author {... author}/>
              </StyledContent.Description>                
            )}
          </div>
          <Share/>
          <div style={{position:'absolute'}}></div>
        </StyledTime>
        {!!similar && !!similar.length && (
          <StyledContent.SliderWrap>
            <ContentSection type="block" pb="none" pt="large">
              <StyledTitle size="large" mb="medium" as="h2">
                Other articles
              </StyledTitle>
              <ArticlesSlider items={similar}/>
            </ContentSection>
          </StyledContent.SliderWrap>
        )}
        {(next || previous) && (
          <ContentSection type="block" pb="none" pt="none">
            <StyledTime space>
              <div>
                {!!previous && <ActiveLink href={prevHref} as={prevAs}>
                  <StyledContent.Link reverse={true} size="large">
                    <ArrowButton reverse={true}/>
                    Read Previous                 
                  </StyledContent.Link>
                </ActiveLink>}
              </div>
              <div>
                {!!next && <ActiveLink href={nextHref} as={nextAs}>
                  <StyledContent.Link size="large">
                    Read Next
                    <ArrowButton />
                  </StyledContent.Link>
                </ActiveLink>}
              </div>
            </StyledTime>
          </ContentSection>
        )}
      </StyledContent.Container>
    </StyledContent>
  )
}
